<template>
	<div
		class="sm:max-h-[543.33px] max-h-[316.13px] invisible-scrollbar max-w-[249.45px] sm:max-w-[404px] rounded-[6px] w-full p-[16px] overflow-hidden"
	>
		<div class="moveY gap-y-5 custom-transition-3 flexed items-center justify-center flex-col-reverse">
			<span v-for="index in 2" :key="'effect-' + index">
				<slot />
			</span>
		</div>
	</div>
</template>
